import { useCallback, useMemo } from 'react'
import { Graphics, Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { formatToCommaWithLang } from '../../util/formatUtil'
import { FixedContainer } from '../../UI'
import { Draw } from '../../type/PixiType'
import { t } from '../../domain/language/languageUtil'

const x = 11
const y = 1170
const width = 700
const height = 80
const bottomRadius = 12
const borderWidth = 2
const colWidth = (width - borderWidth * 2) / 3

const titleStyle = new TextStyle({
  fontSize: 20,
  fill: '#777777',
})

const amountStyle = new TextStyle({
  fontSize: 20,
  fill: '#C5C5C5',
  align: 'right',
})

interface BetHistoryFooterProps {
  betCount: number
  totalPayout: number
  totalStake: number
}

export const BetHistoryFooterPortrait = (props: BetHistoryFooterProps) => {
  const drawBorder = useCallback<Draw>((graphics) => {
    graphics.clear()
    // 考慮邊框寬度的實際繪圖區域
    const drawWidth = width - borderWidth
    const drawHeight = height - borderWidth
    // 開始填充和設置線條樣式
    graphics.beginFill('#171717')
    graphics.lineStyle(borderWidth, '#AFAFB0')
    // 移動到起始點，考慮邊框寬度的一半
    graphics.moveTo(borderWidth / 2, borderWidth / 2)
    // 繪製上邊
    graphics.lineTo(drawWidth, borderWidth / 2)
    // 繪製右邊
    graphics.lineTo(drawWidth, drawHeight - bottomRadius)
    // 繪製右下角的圓角
    graphics.arcTo(
      drawWidth,
      drawHeight,
      drawWidth - bottomRadius,
      drawHeight,
      bottomRadius,
    )
    // 繪製底邊
    graphics.lineTo(bottomRadius, drawHeight)
    // 繪製左下角的圓角
    graphics.arcTo(
      borderWidth / 2,
      drawHeight,
      borderWidth / 2,
      drawHeight - bottomRadius,
      bottomRadius,
    )
    // 繪製左邊，回到起始點
    graphics.lineTo(borderWidth / 2, borderWidth / 2)
    // 結束填充
    graphics.endFill()
  }, [])

  const lines = useMemo(() => {
    const output: Draw[] = []
    for (let i = 0; i < 2; i++) {
      const line: Draw = (g) => {
        g.clear()
        g.lineStyle(borderWidth, '#AFAFB0') // 2 pixels thick, red color
        const x = colWidth * (i + 1)
        g.moveTo(x, 0)
        g.lineTo(x, height - 1)
      }
      output.push(line)
    }
    return output
  }, [])

  return (
    <FixedContainer width={width} height={height} x={x} y={y}>
      <Graphics draw={drawBorder} />
      <Text text={t('betList_total_record')} x={120} y={20} anchor={[0.5, 0.5]} style={titleStyle} />
      <Text text={props.betCount.toString()} x={120} y={50} anchor={[0.5, 0.5]} style={amountStyle} />
      <Graphics draw={lines[0]} />
      <Text text={t('betList_total_stake')} x={350} y={20} anchor={[0.5, 0.5]} style={titleStyle} />
      <Text text={formatToCommaWithLang(props.totalStake)} x={350} y={50} anchor={[0.5, 0.5]} style={amountStyle} />
      <Graphics draw={lines[1]} />
      <Text text={t('betList_payout')} x={590} y={20} anchor={[0.5, 0.5]} style={titleStyle} />
      <Text text={formatToCommaWithLang(props.totalPayout)} x={590} y={50} anchor={[0.5, 0.5]} style={amountStyle} />
    </FixedContainer>
  )
}
